const ADD_TITLE = "Added"
const EDIT_TITLE = "Edited";
const ARCHIVE_TITLE = "Archived";
const RETRIEVE_TITLE = "Retrieved";
const DELETE_TITLE = "Deleted";

const ADD_DESCRIPTION = "has been added!";
const EDIT_DESCRIPTION = "has been edited!";
const ARCHIVE_DESCRIPTION = "has been archived!";
const RETRIEVE_DESCRIPTION = "has been retrieved!";
const DELETE_DESCRIPTION = "has been deleted!";

export{
    ADD_TITLE,
    ADD_DESCRIPTION,
    EDIT_TITLE,
    EDIT_DESCRIPTION,
    ARCHIVE_TITLE,
    ARCHIVE_DESCRIPTION,
    RETRIEVE_TITLE,
    RETRIEVE_DESCRIPTION,
    DELETE_TITLE,
    DELETE_DESCRIPTION,
}